import * as Yup from 'yup';

export const TEST_ATTACHMENT_VALIDATION_SCHEMA = Yup.object().shape({
  testId: Yup.number().required('Обязательное поле'),
});
